import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ThemeProvider, createTheme } from '@mui/material';
import CssBaseline from '@mui/material/CssBaseline';
import Navbar from './components/Navbar';
import Home from './pages/Home';
import CadastroAviso from './pages/CadastroAviso';
import ListaAvisos from './pages/ListaAvisos';
import FloatingMenu from './components/FloatingMenu';
import Exibir from './pages/Exibir';

const theme = createTheme({
  palette: {
    primary: {
      main: '#1976d2',
    },
    secondary: {
      main: '#dc004e',
    },
  },
});

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Router>
        <Navbar />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/cadastro" element={<CadastroAviso />} />
          <Route path="/avisos" element={<ListaAvisos />} />
          <Route path="/exibir" element={<Exibir />} />
          <Route path="/avisos/editar/:id" element={<CadastroAviso />} />
          <Route path="/avisos/novo" element={<CadastroAviso />} />
        </Routes>
        <FloatingMenu />
      </Router>
    </ThemeProvider>
  );
}

export default App; 